import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  constructor(private http: HttpClient, private api: ApiService) {}

  log(event: string, details: any = {}) {
    return this.http.post(this.api.baseurl + '/logs', {
      event,
      details,
      user: this.api.user?.uid || null,
      timestamp: new Date().toISOString(),
    }).toPromise();
  }
}
